import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { NAVIGATION_DEFAULT_LOCALE, type TNavigationLocales } from 'src/types/locales'

export const useLocale = () => {
  const { locale } = useParams<{ locale: TNavigationLocales }>()
  const { i18n } = useTranslation()
  const navigate = useNavigate()

  const currentLocale: TNavigationLocales = locale || NAVIGATION_DEFAULT_LOCALE

  const changeLocale = (newLocale: TNavigationLocales) => {
    const currentPath = window.location.pathname
    const newPath = currentPath.replace(`/${currentLocale}`, `/${newLocale}`)
    i18n.changeLanguage(newLocale)
    navigate(newPath)
  }

  return {
    locale: currentLocale,
    changeLocale,
  }
}
